import { ReactNode, useState } from 'react';
import { useTenant } from 'lib/hooks/useTenant';
import { sessionIdService } from 'services/session-id/session-id.service';
import { TncApprovalContext } from './tnc-approval.context';

type Props = {
  children: ReactNode;
};

const ApprovalStateProvider = ({ children }: Props) => {
  const [isApproved, setIsApproved] = useState(false);

  return (
    <TncApprovalContext.Provider value={{ isApproved, setIsApproved }}>
      {children}
    </TncApprovalContext.Provider>
  );
};

const TncApprovalProvider = ({ children }: Props) => {
  const sessionId = sessionIdService.get();
  const { isDA, isGwat } = useTenant();
  const tenant = isDA ? 'dealsaway' : isGwat ? 'gwat' : 'unsupported';
  const contextKey = `${tenant}:${sessionId}`;

  return (
    <ApprovalStateProvider key={contextKey}>{children}</ApprovalStateProvider>
  );
};

export { TncApprovalProvider };
